import React from 'react'
import Title from '../../../../../../components/typography/title.component.jsx'
import Container from '../../../../../../components/layout/container.component.jsx'
import DetailsForm from '../../components/details-form.component'
import AccordionSecondary from '../../../../../../components/accordion/accordion-secondary.component.jsx'
import { routes } from '../../../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../../actions/toast.actions'
import { CouponService } from '../../../../../../services/coupon.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../../ducks/site/site'

class CouponDetailsPageComponent extends React.Component {
	componentDidMount() {
		const { showLoading, hideLoading, match } = this.props
		const { couponId } = match.params

		showLoading()
		CouponService.getDetails(couponId).then(({ data }) => {
			const {
				status,
				dateEnd,
				dateStart,
				busCompany,
				couponCode,
				couponType,
				couponsAmount,
				moveflexNumber,
				redeemedCoupons,
				couponsPerClient,
				couponDescription,
				discountPercentage,
				boardingDate,
				boardingDateEnd,
				validForRoundTrip,
				busClasses,
				paymentMethod,
				daysInAdvanceForBoarding,
				origins,
				destinations,
				agencyFilter,
				salesOriginFilter,
			} = data
			const formatDate = (date) => {
				if (!date) return ''
				const localDate = new Date(date)
				const year = localDate.getFullYear()
				const month = String(localDate.getMonth() + 1).padStart(2, '0')
				const day = String(localDate.getDate()).padStart(2, '0')
				return `${year}-${month}-${day}`
			}
			this.refs.form.setValues({
				dateEnd: formatDate(dateEnd),
				dateStart: formatDate(dateStart),
				busCompany,
				couponType,
				active: status,
				moveflexNumber,
				redeemedCoupons,
				code: couponCode,
				discountPercentage,
				couponsAmount: couponsAmount,
				description: couponDescription,
				couponsPerCustomer: couponsPerClient,
				boardingDate,
				boardingDateEnd,
				validForRoundTrip,
				busClasses: busClasses || '',
				paymentMethod,
				daysInAdvanceForBoarding,
				origins: origins || '',
				destinations: destinations || '',
				agencyFilter,
				salesOriginFilter,
			})
			hideLoading()
		})
	}

	render() {
		return (
			<Container>
				<Title>Cupom de desconto</Title>
				<AccordionSecondary
					noAnimated
					noClickable
					arrow={false}
					multiple={false}
					items={getAccordionItems.call(this)}
				/>
			</Container>
		)
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Dados do Cupom',
			content: (
				<DetailsForm
					ref={'form'}
					onSubmit={handleSubmit.bind(this)}
					history={this.props.history}
				/>
			),
		},
	]
}

function handleSubmit(values) {
	const { showLoading, hideLoading, history, success, match } = this.props
	showLoading()

	CouponService.update(match.params.couponId, values).then(
		({ errors, ...data }) => {
			hideLoading()
			if (data.success) {
				success({ message: 'Cupom atualizado com sucesso' })
				history.push(`${routes.ADMIN}/cupons-de-desconto`)
			}
		}
	)
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
		},
		dispatch
	)

const connectedCouponDetailsPageComponent = withRouter(
	connect(null, mapDispatchToProps)(CouponDetailsPageComponent)
)

export { connectedCouponDetailsPageComponent as ModuleRootComponent }
